module.exports = __webpack_public_path__ + "media/images/icons/footer-icon-ig-hover-f24a7117d8f7bdb3964edfab30d18b1d.png";